import React from 'react';
import './CSS/Footer.css'; // new footer-specific styles

function Footer() {
  return (
    <footer className="footer-main position-relative">
      <div className="container">
        <div className="row align-items-center gy-3">
          {/* Logo and foundation info */}
          <div className="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
  {/* Logo First */}
  <div
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1rem',
    flexWrap: 'wrap',
  }}
>
  {/* Logo */}
  <img
    src="/logodarvik.png"
    alt="Darvik Foundation Logo"
    style={{
      height: '50px',
      width: 'auto',
      marginRight: '1rem',
    }}
  />

  {/* Title Block */}
  <div style={{ textAlign: 'left', lineHeight: '1.2' }}>
    <div
      style={{
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: '1.25rem',
      }}
    >
      DARVIK
    </div>
    <div
      style={{
        fontWeight: 'normal',
        fontSize: '1rem',
        letterSpacing: '0.5px',
      }}
    >
      FOUNDATION
    </div>
  </div>
</div>
<div
  style={{
    textTransform: 'uppercase',
    fontSize: '0.85rem',
    letterSpacing: '0.5px',
    textAlign: 'center',
    marginTop: '-0.5rem',
  }}
>
  Nurturing Lives. Inspiring Hope. Transforming Futures.
</div>


</div>



          {/* Contact info */}
          <div className="col-12 col-md-4 text-center mb-2 mb-md-0">
            <div className="mb-2 fw-semibold footer-heading">Contact</div>
            <div>
              <a
                href="tel:+919876543210"
                className="footer-link"
              >
                +91-99466-13508
              </a>
            </div>
            <div>
              <a
                href="mailto:contact@darvikfoundation.org"
                className="footer-link dotted"
              >
                contact@darvikfoundation.org
              </a>
            </div>
            
          </div>

          {/* Social Media Links */}
          <div className="col-12 col-md-4 text-center text-md-end">
            <div className="mb-2 fw-semibold footer-heading">Follow Us</div>
            <div className="footer-social d-flex justify-content-center justify-content-md-end gap-3">
              <a
                href="https://facebook.com/darvikfoundation"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://instagram.com/darvikfoundation"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://youtube.com/@darvikfoundation?si=uOKhw_eJteQtLyyk"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Youtube"
              >
                <i className="bi bi-youtube"></i>
              </a>
              <a
                href="https://linkedin.com/company/darvikfoundation"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="row">
  <div className="col-12 text-center footer-bottom">
    &copy; {new Date().getFullYear()} Darvik Foundation. All rights reserved.
    <br />
    <span>
      Developed by{" "}
      <a
        href="https://sriramprasadm.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link underline"
      >
        Mahendran Sriramrasad
      </a>
    </span>
    <br />
    {/* Razorpay-required Policy Links */}
    <div className="footer-policies mt-2">
      <a href="/terms-and-conditions" className="footer-link">Terms & Conditions</a> |{" "}
      <a href="/privacy-policy" className="footer-link">Privacy Policy</a> |{" "}
      <a href="/refund-policy" className="footer-link">Refund & Cancellation Policy</a>
    </div>
  </div>
</div>

      </div>
    </footer>
  );
}

export default Footer;
